import { useAuth } from "./authentication"

const AuthGuard = ({ children }) => {
    const { isAuthenticated } = useAuth();

    if (!isAuthenticated) {
        return <div></div>;
    }
    else {
        return children;
    }
};

export default AuthGuard;